import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { Button } from '@/components/ui/button';
import { Edit2, CheckCircle2 } from 'lucide-react';
import type { PromptSectionName } from '@/types/api/prompt-versions';
import { PROMPT_SECTION_LABELS } from '@/types/api/prompt-versions';

interface PromptSectionAccordionProps {
  sections: Record<PromptSectionName, string | null>;
  onEditSection: (section: PromptSectionName) => void;
}

const SECTION_KEYS: PromptSectionName[] = ['identity', 'mission', 'tone', 'capabilities', 'responseRules'];

export function PromptSectionAccordion({ sections, onEditSection }: PromptSectionAccordionProps) {
  return (
    <Accordion type="multiple" className="w-full">
      {SECTION_KEYS.map((sectionKey) => {
        const value = sections[sectionKey];
        const hasValue = value && value.trim().length > 0;

        return (
          <AccordionItem key={sectionKey} value={sectionKey}>
            <AccordionTrigger className="text-base font-medium hover:no-underline">
              <div className="flex items-center gap-2">
                {hasValue ? (
                  <CheckCircle2 className="h-4 w-4 text-green-500" />
                ) : (
                  <div className="h-4 w-4 rounded-full border-2 border-muted-foreground/30" />
                )}
                {PROMPT_SECTION_LABELS[sectionKey]}
              </div>
            </AccordionTrigger>
            <AccordionContent>
              <div className="space-y-3 pt-2">
                {hasValue ? (
                  <div className="p-3 bg-muted/50 rounded-lg">
                    <p className="text-sm text-foreground whitespace-pre-wrap line-clamp-4">
                      {value}
                    </p>
                  </div>
                ) : (
                  <div className="p-3 bg-muted/30 rounded-lg border border-dashed">
                    <p className="text-sm text-muted-foreground italic">
                      Usando valor padrão do sistema
                    </p>
                  </div>
                )}
                <Button
                  variant="outline"
                  size="sm"
                  className="w-full"
                  onClick={() => onEditSection(sectionKey)}
                >
                  <Edit2 className="h-4 w-4 mr-2" />
                  Editar {PROMPT_SECTION_LABELS[sectionKey]}
                </Button>
              </div>
            </AccordionContent>
          </AccordionItem>
        );
      })}
    </Accordion>
  );
}
